import { render, staticRenderFns } from "./UserOrderSelect.vue?vue&type=template&id=79e17fbc&scoped=true&"
import script from "./UserOrderSelect.vue?vue&type=script&lang=js&"
export * from "./UserOrderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e17fbc",
  null
  
)

export default component.exports